import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { TranslationService } from '../../services/translation.service';
import { LanguageSwitcherComponent } from '../language-switcher/language-switcher.component';
import { Locale } from '../language-switcher/language.interface';


@Component({
  selector: 'app-settings-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDividerModule,
    TranslateModule,
    FormsModule,
    LanguageSwitcherComponent
  ],
  templateUrl: './settings-dialog.html',
  styleUrls: ['./settings-dialog.scss']
})
export class SettingsDialogComponent  {
  private dialogRef = inject(MatDialogRef<SettingsDialogComponent>);
  private translationService = inject(TranslationService);

  selectedLanguage: Locale;
  languages = [
    { code: 'en-US', label: 'English' },
    { code: 'pl-PL', label: 'Polski' }
  ];

  constructor() {
    this.selectedLanguage = (this.translationService.getCurrentLanguage());
  }


  onLanguageChange(language: Locale): void {
    this.translationService.setLanguage(language);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
